<style>
    .my-drop-zone { border: dotted 3px lightgray; }
    .nv-file-over { border: dotted 3px red; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }

    html, body { height: 100%; }
</style>

<c-card *transloco="let t">
    <c-card-body>

<div class="container">
    <c-row>
      <c-col md="8">
          <h1>{{ t('Import Monitors')}}</h1>
      </c-col>
      <c-col  md="4" class="text-end">
        <div class="btn-group mb-2 " role="group">
          <button color="light" cButton  routerLink="/mgmt/monitors/monitors">
            <svg cIcon class="me-2" name="cil-chevron-left"></svg>
            {{ t('Return to Monitors') }}
          </button>
          <button type="button" class="btn btn-light" (click)="reset()" *ngIf="step > 1"><i class="fa-solid fa-angles-left"></i> {{ t("Upload another File")}}</button>
          <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352926225553-Uploading-Workers" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
        </div>
        </c-col>
    </c-row>

    <div class="row"  *ngIf="step == 1">

        <p>
          {{ t('You can import workers to OK Alone by using an Excel file.') }} <br />
          {{ t('Please use our') }} <a href="/assets/files/Monitors.xlsx" target="_new">Monitors.xlsx</a> {{ t('file as a template. Please do not change the column order.') }}
          </p>

        <div class="col-md-4">

            <h3>{{ t('Select files') }}</h3>

            <div ng2FileDrop
                 [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                 (fileOver)="fileOverBase($event)"
                 [uploader]="uploader"
                 class="well my-drop-zone"
                 style="width:100%;height:200px;">
                {{ t('Drop your monitor upload file here or select it using the button below') }}
            </div>
            <input type="file" ng2FileSelect [uploader]="uploader" />
        </div>

        <div class="col-md-8" style="margin-bottom: 40px">

            <h3>{{ t('Upload queue') }}</h3>
            <p>{{ t('Queue length') }}: {{ uploader?.queue?.length }}</p>

            <table class="table">
                <thead>
                <tr>
                    <th width="50%">{{ t('Name') }}</th>
                    <th>{{ t('Size') }}</th>
                    <th>{{ t('Progress') }}</th>
                    <th>{{ t('Status') }}</th>
                    <th>{{ t('Actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of uploader.queue">
                    <td><strong>{{ item?.file?.name }}</strong></td>
                    <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                    <td *ngIf="uploader.options.isHTML5">
                        <div class="progress" style="margin-bottom: 0;">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                    </td>
                    <td class="text-center">
                        <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
                        <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
                        <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
                    </td>
                    <td nowrap>
                        <button type="button" class="btn btn-success btn-xs"
                                (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                            <span class="glyphicon glyphicon-upload"></span> {{ t('Upload') }}
                        </button>
                        <button type="button" class="btn btn-warning btn-xs"
                                (click)="item.cancel()" [disabled]="!item.isUploading">
                            <span class="glyphicon glyphicon-ban-circle"></span> {{ t('Cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger btn-xs"
                                (click)="item.remove()">
                            <span class="glyphicon glyphicon-trash"></span> {{ t('Remove') }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <div>
                <div>
                    {{ t('Queue progress') }}:
                    <div class="progress" style="">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                    </div>
                </div>
                <div class="alert alert-danger" role="alert"  *ngIf="file_error">
                  {{file_error}}
                </div>
            </div>

        </div>

    </div>

    <br><br>

    <div class="row" *ngIf="step == 2">
        <div class="col-md-12">

            <p>{{ t('We have processed the monitor upload file. Please check the following monitor data. Only monitors with no errors will be imported or updated.') }}</p>


            <div class="alert alert-danger" role="alert"  *ngIf="upload_errors">
              <b>{{ t('Upload Issue') }}</b> {{ t('We have detected some issues with your upload file. Please check them in the table below, fix them in the file and resubmit the file.') }}
            </div>
            <div class="alert alert-danger" role="alert"  *ngIf="!extra_field_valid">
              <b>{{ t('Upload Issue') }}</b> {{ t('Please choose the fields in the drop down for all the extra fields in your upload file.') }}
            </div>


            <c-row>
                <c-col class="text-center">
                  <button type="button" class="btn btn-primary" (click)="uploadMonitors()"  *ngIf="!upload_errors"><i class="fa-solid fa-file-import"></i> {{ t('Import these Monitors') }}</button>
                  <button type="button" class="btn btn-outline-primary" (click)="reset()"  *ngIf="upload_errors"><i class="fa-solid fa-angles-left"></i> {{ t('Upload Another File') }}</button> <br/><br/>
                </c-col>
            </c-row>


            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Monitor') }}</th>
                        <th scope="col">{{ t('Email') }}</th>
                        <th scope="col">{{ t('Cell/Phone') }}</th>
                        <th scope="col">{{ t('Contact Method') }}</th>
                        <th scope="col">{{ t('Group') }}</th>
                        <td *ngIf="monitors[0].extra_field_1">
                          <ng-select [(ngModel)]="extra_fields[0]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="monitors[0].extra_field_2">
                          <ng-select [(ngModel)]="extra_fields[1]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="monitors[0].extra_field_3">
                          <ng-select [(ngModel)]="extra_fields[2]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="monitors[0].extra_field_4">
                          <ng-select [(ngModel)]="extra_fields[3]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="monitors[0].extra_field_5">
                          <ng-select [(ngModel)]="extra_fields[4]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <th scope="col"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let monitor of monitors" [class.table-success]="!monitor.user_id && monitor.errors.length==0">
                          <td>
                            <h4>
                                <span class="badge bg-secondary" *ngIf="monitor.user_id"><i class="fa-solid fa-check"></i> {{ t('Already Imported') }}</span>
                                <span class="badge bg-primary" *ngIf="!monitor.user_id && monitor.errors.length==0"><i class="fa-solid fa-file-import"></i> {{ t('Ready to Import') }}</span>
                                <span class="badge bg-danger" *ngIf="!monitor.user_id && monitor.errors.length!=0"><i class="fa-solid fa-circle-xmark"></i> {{ t('Data Error') }}</span>
                            </h4>
                          </td>
                          <td>
                            <span><b>{{monitor.name}}</b></span>
                          </td>
                          <td>
                            {{monitor.email}}
                          </td>
                          <td>
                              {{monitor.phone}}
                          </td>
                          <td>
                              <span *ngIf="monitor.contact_email" class="badge bg-info m-1">{{ t('Email') }}</span>
                              <span *ngIf="monitor.contact_sms" class="badge bg-info m-1">{{ t('SMS') }}</span>
                              <span *ngIf="monitor.contact_call" class="badge bg-info m-1">{{ t('Phonecall') }}</span>
                          </td>
                          <td>
                            {{monitor.group}}
                          </td>
                          <td *ngIf="monitor.extra_field_1">
                              {{monitor.extra_field_1}}
                          </td>
                          <td *ngIf="monitor.extra_field_2">
                              {{monitor.extra_field_2}}
                          </td>
                          <td *ngIf="monitor.extra_field_3">
                              {{monitor.extra_field_3}}
                          </td>
                          <td *ngIf="monitor.extra_field_4">
                              {{monitor.extra_field_4}}
                          </td>
                          <td *ngIf="monitor.extra_field_5">
                              {{monitor.extra_field_5}}
                          </td>
                          <td>
                              <ul *ngIf="monitor.errors.length > 0" class="text-danger">
                                  <li *ngFor="let error of monitor.errors">{{error}}</li>
                              </ul>
                          </td>
                          <td>

                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>


    <div class="row" *ngIf="step == 3">
        <div class="col-md-12">

            <p>{{ t('The following monitors have now been imported or updated:') }}</p>

            <button type="button" class="btn btn-info mb-2 text-white text-center" (click)="sendWelcome()">
              <i class="fa-solid fa-paper-plane"></i> {{ t('Send Welcome Email') }}
              <div *ngIf="welcome_loading">
                <i class="fa-solid fa-spinner fa-lg fa-spin"></i>
              </div>
            </button>



            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Monitor') }}</th>
                        <th scope="col">{{ t('Email') }}</th>
                        <th scope="col">{{ t('Cell/Phone') }}</th>
                        <th scope="col">{{ t('Group') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let monitor of monitors2">
                          <td>
                            <h4>
                                <span class="badge bg-success"><i class="fa-solid fa-check"></i> {{ t('Imported') }}</span>
                            </h4>
                          </td>
                          <td>
                            <span><b>{{monitor.name}}</b></span>
                          </td>
                          <td>
                            {{monitor.email}}
                          </td>
                          <td>
                              {{monitor.phone}}
                          </td>
                          <td>

                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>

</div>


</c-card-body>
</c-card>
